<template>
  <div class="backdrop main-Product" id="main-ProductDisplay">
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> {{$t('Jobs')}}</p>
    <p class="caption headline">{{ $t('Jobs')}}</p>
    <!--<p class="caption">招贤纳士</p>-->
    <div class="recruitment">
      <img src="../assets/img/logo/recruitment.png">
      <p class="explain">&nbsp; &nbsp; &nbsp; &nbsp;<span v-html="$t('JobsText')"></span></p>
    </div>
    </div>
</template>

<script>
  export default {
    name: "recruitment",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  .main-Product{
    background-image: url(../assets/img/pic/pic_RECRUITMENT.jpg);
  }
  .recruitment{
    margin: .3rem .7rem;
    position: relative;
  }
  .recruitment img {
    width: 30%;
    margin-left: 15%;
  }
  .explain{
    /*font-size: .3rem;*/
    /*width: 7rem;*/
    /*display: inline-block;*/
    /*position: absolute;*/
    /*right: 0;*/
    /*text-align: justify;*/
    /*font-weight: 100;*/

    font-size: .2rem;
    width: 7rem;
    display: inline-block;
    position: absolute;
    right: 0;
    text-align: justify;
    font-weight: 100;
    line-height: .4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/recruitment.vue